import React from "react";
import { Navigate } from "react-router-dom";

export default function AppPage() {
  return <Navigate to="/apps" replace />;
}
